import React, { useCallback, useState } from 'react';
import { FlatList, RefreshControl, View, StyleSheet } from 'react-native';
import Text from '../../../components/Text';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import LoadingSpinner from '../../../components/LoadingSpinner';
import {
  DeleteAllAlerts,
  FilterAlerts,
  GetAlerts,
  GetNextAlerts,
} from '../alertsReducer';
import { RootStore } from '../../../redux/store';
import NotificationsItem from '../components/NotificationsItem';
import Center from '../../../components/Center';
import Button from '../../../components/Button';
import ActiveFiltersSection from '../components/ActiveFiltersSection';

const Notifications = ({searchTerm = ''}) => {
  const { alerts, filterArgs, loading, pageNumber, nextPage } =
    useSelector((state: RootStore) => state.alerts);
  const { unitLinksHolder } = useSelector((state: RootStore) => state.units);
  const units =
    unitLinksHolder?.map(u => ({
      id: u.unit.id,
      name: u.unitNickname ? u.unitNickname : u.unit.unitName,
    })) || [];

  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [refreshing, setRefreshing] = useState(false);
  const normalizedSearchTerm = searchTerm.trim().toUpperCase();
  const visibleAlerts = normalizedSearchTerm
    ? alerts.filter(alert => {
        const message = alert.message ? alert.message.toUpperCase() : '';
        const eventName = alert.eventName ? alert.eventName.toUpperCase() : '';
        return (
          message.includes(normalizedSearchTerm) ||
          eventName.includes(normalizedSearchTerm)
        );
      })
    : alerts;

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    dispatch(FilterAlerts({ unit: null, eventName: null, startDate: null, endDate: null }));
    dispatch(DeleteAllAlerts());
    dispatch(GetAlerts());
    setRefreshing(false);
  }, []);

  return (
    <>
      {loading && pageNumber === 1 ? (
        <LoadingSpinner />
      ) : (
        <FlatList
          refreshControl={<RefreshControl onRefresh={onRefresh} refreshing={refreshing} />}
          data={visibleAlerts}
          style={styles.flatList}
          contentContainerStyle={styles.listContent}
          showsVerticalScrollIndicator={false}
          ListHeaderComponent={<ActiveFiltersSection units={units} filterArgs={filterArgs} />}
          ListEmptyComponent={
            <Center>
              <Text style={styles.emptyText}>
                No notifications at this moment, try adjusting your filters
              </Text>
            </Center>
          }
          renderItem={({ item }) => (
            <NotificationsItem
              notification={item}
              clickHandler={() =>
                navigation.navigate('Notification Details', {
                  isFromTray: false,
                  alertId: null,
                  id: item.id,
                })
              }
              openApproval={() =>
                navigation.navigate('Approval Detail', {
                  id: item?.approval.id,
                  unitId: item.unit.unitId,
                })
              }
            />
          )}
          ListFooterComponent={
            <View style={styles.footerContainer}>
              {!!nextPage && (
                <Button
                  onPress={() => dispatch(GetNextAlerts())}
                  isLoading={loading && pageNumber !== 1}
                  isLoadingText="Loading more ..."
                  isDisabled={loading && pageNumber !== 1}>
                  Load more
                </Button>
              )}
            </View>
          }
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  flatList: {
    backgroundColor: '#f4f4f5',
    flex: 1,
  },
  listContent: {
    paddingBottom: 96,
    paddingTop: 10,
  },
  emptyText: {
    color: '#71717a',
    marginTop: 64,
    textAlign: 'center',
  },
  footerContainer: { alignItems: 'center', height: 48, marginBottom: 46 },
});

export default Notifications;
